<div class="splash-screen" *ngIf="isLoading$ | async">
  <div class="splash-box">
    <div class="splash-content">
      <mat-spinner diameter="75" color="accent"></mat-spinner>
      <span>Loading application, please wait...</span>
    </div>
  </div>
</div>
